import { Button, Flex, Modal, ModalBody, ModalContent, ModalOverlay, Text } from '@chakra-ui/react';

import { accent } from 'styles/revampTokens';

import type { InputTypeDataLossWarningModalProperties } from 'components/Modals/InputTypeDataLossWarningModal';

// Own component rather than restyling the shared
// `components/Modals/InputTypeDataLossWarningModal` in place — that one is
// also used (unrevamped) by PlanPageDetailsOPZ, BuilderMode, and
// BuilderModeV1, so changing its look there would have changed it there too.
// Same recipe as DashboardRevamp/DimensionsRevamp/Blocks' own local
// DeleteModal components: no ModalHeader/ModalFooter chrome, just centered
// content in a single ModalContent, Comfortaa Bold title, flex-1 buttons
// with a scale-down press state. Purple (accent.solid) primary action here
// instead of the delete-modal's red, since this confirms a change rather
// than a deletion.
const ModernInputTypeDataLossWarningModal = ({
  isOpen,
  onCancel,
  onConfirm,
}: InputTypeDataLossWarningModalProperties) => (
  <Modal isOpen={isOpen} onClose={onCancel} isCentered blockScrollOnMount={false}>
    <ModalOverlay />
    <ModalContent width='411px' maxWidth='90vw' borderRadius='14px' p='18px'>
      <ModalBody p={0}>
        <Flex direction='column' align='center' gap='21px'>
          <Text
            textAlign='center'
            fontFamily='Comfortaa'
            fontWeight='bold'
            fontSize='18px'
            color='#121826'
          >
            Change input type?
          </Text>
          <Text
            textAlign='center'
            fontFamily='Roboto Regular'
            fontSize='13px'
            lineHeight='16px'
            color='#708090'
          >
            Are you sure? Changing this input type will replace your detailed values with a single
            average value. For example, 10, 20, 30 becomes 20. Your original values may be lost.
          </Text>
          <Flex gap='18px' width='100%'>
            <Button
              flex={1}
              bg='white'
              border='1px solid #D9D9D9'
              borderRadius='11px'
              fontFamily='Roboto Regular'
              fontWeight='500'
              fontSize='13px'
              color='#121826'
              p='14px'
              height='auto'
              transition='transform 0.1s ease, background 0.15s ease'
              _hover={{ bg: 'gray.50' }}
              _active={{ transform: 'scale(0.97)' }}
              onClick={onCancel}
            >
              Cancel
            </Button>
            <Button
              flex={1}
              bg={accent.solid}
              borderRadius='11px'
              fontFamily='Roboto Bold'
              fontWeight='700'
              fontSize='13px'
              color='white'
              p='14px'
              height='auto'
              transition='transform 0.1s ease, background 0.15s ease'
              _hover={{ bg: accent.hover }}
              _active={{ transform: 'scale(0.97)' }}
              onClick={onConfirm}
            >
              Confirm
            </Button>
          </Flex>
        </Flex>
      </ModalBody>
    </ModalContent>
  </Modal>
);

export default ModernInputTypeDataLossWarningModal;
